"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// @ts-check
var get = require('lodash/get');

var map = require('lodash/map');

var find = require('lodash/find');

var noop = require('lodash/noop');

var request = require('@flowio/request');

var session = require('@flowio/session');

var _require = require('@flowio/storage'),
    local = _require.local;

var batchedResults = [];
var config = {
  API_BASE_URI: 'https://api.flow.io'
};
var browserBundleDataEventName = 'browser_bundle_data';
/** @typedef {import('@flowio/types/dist/api-internal').BrowserBundle} BrowserBundle */

/**
 * Wrapper around request call to dispatch dom events
 */

function makeRequest(options, callback) {
  var optionsWithEnvelope = _objectSpread({
    envelope: true
  }, options);

  request.authenticated(optionsWithEnvelope, function (status, response) {
    if (callback) {
      callback(status, response);
    }
  });
}

function getOptinMessages(callback) {
  // @ts-ignore
  if (window.Flow && window.Flow.set) {
    // @ts-ignore
    window.Flow.set('on', browserBundleDataEventName,
    /** @type {(bundleData: BrowserBundle) => void} */
    function (bundleData) {
      return callback(200, bundleData.optins);
    }); // @ts-ignore
  } else if (window.flow && window.flow.cmd) {
    // @ts-ignore
    window.flow.cmd('on', browserBundleDataEventName,
    /** @type {(bundleData: BrowserBundle) => void} */
    function (bundleData) {
      return callback(200, bundleData.optins);
    });
  } else if (session.getCountry()) {
    makeRequest({
      url: "".concat(config.API_BASE_URI, "/").concat(session.getOrganization(), "/optin/targets/browse/").concat(session.getCountry(), "?expand=content&cast=markdown_to_html")
    }, callback);
  }
}

function postAnswers(data, callback) {
  if (session.getExperience()) {
    makeRequest({
      method: 'POST',
      data: data,
      url: "".concat(config.API_BASE_URI, "/").concat(session.getOrganization(), "/optin/activities")
    }, callback);
  }
}

function formatLocalResults(optinLocalResult) {
  return {
    key: optinLocalResult.optin_attribute_key,
    consent: optinLocalResult.consent_granted,
    lastPromptedOn: optinLocalResult.last_seen_at,
    lastActedOn: optinLocalResult.last_acted_at,
    region: optinLocalResult.optin_region,
    isNotice: optinLocalResult.is_notice,
    wasDismissed: optinLocalResult.was_dismissed
  };
}

function getOptinResults() {
  var optinResults = local.get('optinResults');
  return map(optinResults, function (optinResult) {
    return formatLocalResults(optinResult);
  });
}

function clearOptinResults(key) {
  var optinResults = local.get('optinResults');
  delete optinResults[key];
  local.set('optinResults', optinResults);
}

function getValidOptinMessages(consentMessages) {
  var consentResults = getOptinResults();
  return consentMessages.filter(function (consentMessage) {
    var consentResultForMessage = find(consentResults, function (result) {
      return result.key === get(consentMessage, 'optin_attribute.optin_attribute_key');
    });

    if (!consentResultForMessage) {
      return true;
    } // If the optin was seen but not acted on, we want to show it
    // if it isn't a notice of course


    if (!consentResultForMessage.lastActedOn && !consentResultForMessage.isNotice) {
      return true;
    }

    if (consentResultForMessage.region !== get(session.getSession(), 'experience.region.id')) {
      return true;
    }

    if (consentResultForMessage.isNotice && !consentResultForMessage.wasDismissed) {
      return true;
    }

    var lastAcceptedTime = new Date(consentResultForMessage.lastActedOn).getTime();
    var lastUpdatedTime = new Date(consentMessage.enforce_on).getTime();

    if (lastAcceptedTime < lastUpdatedTime) {
      clearOptinResults(get(consentMessage, 'optin_attribute.optin_attribute_key'));
    }

    return lastAcceptedTime < lastUpdatedTime;
  });
}

function onDisplayOptin(key, isNotice, _ref) {
  var batch = _ref.batch;
  var optinResults = local.get('optinResults');
  var currentResult = get(optinResults, key) || {};
  var optinDisplayTime = new Date().toISOString();
  currentResult.optin_attribute_key = key;
  currentResult.optin_region = get(session.getSession(), 'experience.region.id');
  currentResult.consent_granted = isNotice;
  currentResult.is_notice = isNotice;
  currentResult.last_seen_at = optinDisplayTime;
  optinResults[key] = currentResult;
  local.set('optinResults', optinResults);

  if (batch) {
    batchedResults.push(currentResult);
  } else {
    postAnswers([currentResult]);
  }
}

function dismissNotice(key) {
  var optinResults = local.get('optinResults');
  var currentResult = get(optinResults, key) || {};
  var optinDisplayTime = new Date().toISOString();
  currentResult.optin_attribute_key = key;
  currentResult.optin_region = get(session.getSession(), 'experience.region.id');
  currentResult.last_seen_at = optinDisplayTime;
  currentResult.consent_granted = true;
  currentResult.was_dismissed = true;
  optinResults[key] = currentResult;
  local.set('optinResults', optinResults);
}

function onOptinAction(key, _ref2) {
  var action = _ref2.action,
      batch = _ref2.batch;
  var optinResults = local.get('optinResults');
  var currentResult = get(optinResults, key) || {};
  var optinActedTime = new Date().toISOString();
  currentResult.optin_attribute_key = key;
  currentResult.optin_region = get(session.getSession(), 'experience.region.id');
  currentResult.consent_granted = action;
  currentResult.last_acted_at = optinActedTime;
  optinResults[key] = currentResult;
  local.set('optinResults', optinResults);

  if (batch) {
    batchedResults.push(currentResult);
  } else {
    postAnswers([currentResult]);
  }
}

function sendBatchedResults() {
  postAnswers(batchedResults, function () {
    batchedResults = [];
  });
}

function displayOptinMessages(render, consentMessages, targetContainer, onRender) {
  if (consentMessages.error) {
    return;
  }

  var messagesToDisplay = getValidOptinMessages(consentMessages);
  var parentContainer;

  if (window.document.querySelectorAll('.flow-consent-container').length > 0) {
    var _window$document$quer = window.document.querySelectorAll('.flow-consent-container');

    var _window$document$quer2 = _slicedToArray(_window$document$quer, 1);

    parentContainer = _window$document$quer2[0];
  } else {
    parentContainer = window.document.createElement('div');
    parentContainer.setAttribute('class', 'flow-consent-container');

    if (targetContainer) {
      var _window$document$quer3 = window.document.querySelectorAll(targetContainer),
          _window$document$quer4 = _slicedToArray(_window$document$quer3, 1),
          targetContainerEle = _window$document$quer4[0];

      if (targetContainerEle) {
        targetContainerEle.appendChild(parentContainer);
      }
    } else {
      window.document.body.appendChild(parentContainer);
    }
  }

  messagesToDisplay.forEach(function (message) {
    return render(message, onDisplayOptin, onOptinAction, parentContainer);
  });
  onRender();
}

function optinDecision(key, onAction, _ref3) {
  var action = _ref3.action;
  onAction(key, {
    action: action,
    batch: false
  });
  var optinElement = window.document.querySelector("#".concat(key));

  if (optinElement) {
    optinElement.remove();
  }
}

function defaultRender(prompt, onDisplay, onAction, parentContainer) {
  var contentDiv = window.document.createElement('div');
  var messageSpan = window.document.createElement('span');
  var key = get(prompt, 'optin_attribute.optin_attribute_key'); // Will remove an existing message, instead of not rendering.
  // Mainly because if it is an updated message we do want to show it.

  if (window.document.querySelectorAll("#".concat(key)).length > 0) {
    window.document.querySelectorAll("#".concat(key))[0].remove();
  }

  contentDiv.setAttribute('id', key);
  messageSpan.setAttribute('class', 'flow-consent-message');
  messageSpan.innerHTML = get(prompt, 'content.elements.text.value');
  contentDiv.appendChild(messageSpan);

  if (prompt.options.includes('notice_only')) {
    contentDiv.setAttribute('class', 'flow-consent-message-container-notice');
    var dismissLink = window.document.createElement('a');
    dismissLink.setAttribute('class', 'flow-consent-dismiss-btn');
    dismissLink.innerHTML = get(prompt, 'content.elements.dismiss.value');

    dismissLink.onclick = function () {
      var optinElement = window.document.querySelector("#".concat(key));

      if (optinElement) {
        dismissNotice(key);
        optinElement.remove();
      }
    };

    contentDiv.appendChild(dismissLink);
    onDisplay(key, true, {
      batch: true
    });
    onAction(key, {
      action: true,
      batch: true
    });
  } else {
    contentDiv.setAttribute('class', 'flow-consent-message-container-action');
    var positive = window.document.createElement('span');
    var negative = window.document.createElement('span');
    positive.innerText = get(prompt, 'content.elements.accept.value');
    positive.setAttribute('class', 'flow-consent-decision-positive');

    positive.onclick = function () {
      optinDecision(key, onAction, {
        action: true
      });
    };

    negative.innerText = get(prompt, 'content.elements.reject.value');
    negative.setAttribute('class', 'flow-consent-decision-negative');

    negative.onclick = function () {
      optinDecision(key, onAction, {
        action: false
      });
    };

    contentDiv.appendChild(positive);
    contentDiv.appendChild(negative);
    onDisplay(key, false, {
      batch: true
    });
  }

  parentContainer.appendChild(contentDiv);
}

function getAndDisplayOptin() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref4$targetElement = _ref4.targetElement,
      targetElement = _ref4$targetElement === void 0 ? undefined : _ref4$targetElement,
      _ref4$shouldSetTimeou = _ref4.shouldSetTimeout,
      shouldSetTimeout = _ref4$shouldSetTimeou === void 0 ? false : _ref4$shouldSetTimeou,
      _ref4$render = _ref4.render,
      render = _ref4$render === void 0 ? defaultRender : _ref4$render,
      _ref4$onRender = _ref4.onRender,
      onRender = _ref4$onRender === void 0 ? noop : _ref4$onRender;

  if (!local.get('optinResults')) {
    local.set('optinResults', {});
  }

  getOptinMessages(function (_status, response) {
    if (!response.error) {
      displayOptinMessages(render, response, targetElement, onRender);

      if (batchedResults.length > 0) {
        sendBatchedResults();
      }
    }
  });

  if (shouldSetTimeout) {
    // Will get new consent messages every 10 minutes
    setTimeout(function () {
      return getAndDisplayOptin({
        render: render,
        onRender: onRender
      });
    }, 600000);
  }
}

function getResultForKey(key) {
  var optinResults = local.get('optinResults');
  var resultForKey = find(optinResults, function (result) {
    return result.optin_attribute_key === key;
  });
  return resultForKey ? formatLocalResults(resultForKey) : undefined;
}

module.exports = {
  getAndDisplayOptin: getAndDisplayOptin,
  getResultForKey: getResultForKey
};


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/optin/lib/index.js
// module id = 149
// module chunks = 0 1